import { useMemo } from "react";
import { ParamToKey } from "@/utilities/tracking";

/**
 * Extracts UTM parameters from URL search params
 * Returns only parameters defined in ParamToKey mapping
 * SSR-safe: Returns undefined in non-browser environments
 */
export const useUserTrackingProperties = (): URLSearchParams | undefined => {
  return useMemo(() => {
    // SSR-safe: Only access window in browser environment
    if (typeof window === "undefined") {
      return undefined;
    }

    const query = new URLSearchParams(window.location.search);
    const filteredEntries = [...query.entries()].filter(
      ([key]) => key in ParamToKey
    );

    return filteredEntries.length > 0
      ? new URLSearchParams(filteredEntries)
      : undefined;
  }, []); // Empty deps: extract UTM params once on mount
};
